import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ o("path", { d: "M35.295 5.79h1.92c.53 0 .96.43.96.96v34.458c0 .53-.43.96-.96.96h-1.92a.96.96 0 0 1-.96-.96V6.75c0-.53.43-.96.96-.96ZM10.062 7.623l1.359-1.353-.021-.012a.96.96 0 0 1 1.353 0l17.721 17.7-17.7 17.7a.96.96 0 0 1-1.353 0l-1.359-1.353a.992.992 0 0 1-.207-.3.96.96 0 0 1 0-.735.994.994 0 0 1 .207-.3l15-15-15-15a.955.955 0 0 1-.21-.3.975.975 0 0 1 0-.736.949.949 0 0 1 .21-.311Z" }, null, -1), l = [
  n
];
function r(a, s) {
  return e(), t("svg", c, l);
}
const h = { render: r };
export {
  h as default,
  r as render
};
//# sourceMappingURL=last-page.svg.mjs.map
